import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1d407dae&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d407dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d407dae')) {
      api.createRecord('1d407dae', component.options)
    } else {
      api.reload('1d407dae', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1d407dae&scoped=true&", function () {
      api.rerender('1d407dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z6ChLCLie0Mq/JS/comp/Accordion.vue"
export default component.exports